const AppName = "Potowatomi Kids Zone";
const Language = "Potowatomi";
const Tribe = "Pokagon Band of Potawatomi";
const FirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY_POKAGON,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_POKAGON,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_POKAGON,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_POKAGON,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_POKAGON,
  appId: process.env.REACT_APP_FIREBASE_APP_ID_POKAGON,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_POKAGON,
};
const FilePath = "https://storage.googleapis.com/pokagon-media/";
const NacaApiUrl = process.env.REACT_APP_NACA_API_URL || "https://naca.community";
const NacaCommunityId = "451d58a0-6fa0-463f-a727-0556bee1e6ae";

const SheetsToPull = [
  { collection: "KZ_AppData", nameToSave: "vocabData" },
  { collection: "KZ_GameDescriptions", nameToSave: "gameDescriptions" },
  { collection: "KZ_GameFilterDataNew", nameToSave: "gameData" },
  { collection: "KZ_PopupWords", nameToSave: "popupWords" },
  { collection: "KZ_uiWords", nameToSave: "uiWords" },
];

const ParamsToFindGame = [
  // Double Check for correctenss
  { data: "category", param: "unit" },
  { data: "target", param: "game-name" },
];

const NumberDataCategory = "Numbers 1";

const FeedbackLink = "";

const BottomColor = "rgba(34,104,10,1)";

const VersionNumber = "2.02.00056";

const Credits = {
  credits: [
    "Website created and designed through Native Teaching Aids LLC by Thomas Koefod and Spencer Kittle",
  ],
  links: [
    {
      link: "https://www.nativeteachingaids.com",
      image: "ntalogo.png",
      style: "short",
    },
  ],
};

const PossibleGames = [
  "Bubble Pop",
  "Counting",
  "Good Guess",
  "Matching",
  "Whack-A-Mole",
  "Word To Image",
  "Verb Activity",
  "Wordless",
];

const config = {
  AppName,
  Language,
  Tribe,
  FirebaseConfig,
  FilePath,
  NacaApiUrl,
  NacaCommunityId,
  SheetsToPull,
  ParamsToFindGame,
  FeedbackLink,
  BottomColor,
  NumberDataCategory,
  VersionNumber,
  Credits,
  PossibleGames,
};

export default config;

export {
  AppName,
  Language,
  Tribe,
  FirebaseConfig,
  FilePath,
  NacaApiUrl,
  NacaCommunityId,
  SheetsToPull,
  ParamsToFindGame,
  FeedbackLink,
  BottomColor,
  NumberDataCategory,
  VersionNumber,
  Credits,
  PossibleGames,
};
